module.exports = __webpack_public_path__ + "img/horn.43443dc4.svg";